import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=53cdb557&scoped=true"
import script from "./BankCard.vue?vue&type=script&lang=js"
export * from "./BankCard.vue?vue&type=script&lang=js"
import style0 from "./BankCard.vue?vue&type=style&index=0&id=53cdb557&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cdb557",
  null
  
)

export default component.exports